module.exports = __webpack_public_path__ + "img/课程介绍_05.a69753ff.jpg";